import { i18nCore } from '@core-frontend/core-frontend';
import { toast } from 'react-toastify';

import { useMutate } from '@/shared/model/hooks';

import { companyOnboardingAsync } from '../api';

export const useCompanyOnboardingMutation = () => {
  return useMutate(companyOnboardingAsync, {
    onSuccess: () => {
      toast.success(
        i18nCore.t('common.Messages.Successfully.CompanyOnboarding', {
          defaultValue: 'Company onboarding successfully',
        }),
        {
          position: 'top-center',
        }
      );
    },
  });
};
